var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "damages-extra-details detail-cart-confirmed view" },
    [
      _c(
        "div",
        { staticClass: "view_top" },
        [
          _c("ma-navbar-category", {
            attrs: {
              titleNavbar: _vm.$t("damagesConfirmed.titleDamagesConfirmed"),
              qaName: "go-to-damagesConfirmed-btn",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "view_content" }, [
        _c("ul", { staticClass: "damage-category_list mg mg--t-8" }, [
          _c("div", { staticClass: "container-detailed-damages" }, [
            _c(
              "div",
              { staticClass: "cart-detail-damage" },
              [
                _c("p", { staticClass: "headline-large gray" }, [
                  _vm._v(
                    _vm._s(_vm.getSubtitle(_vm.damagesDetails.selfcare_title))
                  ),
                ]),
                _c("p", { staticClass: "headline-medium gray mg mg--b-4" }, [
                  _vm._v(" " + _vm._s(_vm.damagesDetails.selfcare_subtitle)),
                ]),
                _c("svgicon", {
                  attrs: {
                    name: "more-vertical",
                    color: "#566473",
                    height: "21",
                    width: "21",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showDeleteBtn = !_vm.showDeleteBtn
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "delete-damage_btn",
                    class: { deleteBtnIsVisible: _vm.showDeleteBtn },
                    on: { click: _vm.handleDeleteDamage },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "container-btn" },
                      [
                        _c("svgicon", {
                          attrs: {
                            name: "delete-trash",
                            color: "#EF4136",
                            height: "13",
                            width: "15",
                          },
                        }),
                        _c("p", { staticClass: "text-medium redVidid" }, [
                          _vm._v(_vm._s(_vm.$t("actions.suppress")) + " "),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.surfaceIsVisible(
                      _vm.damagesDetails.selfcare_subtitle
                    ),
                    expression:
                      "surfaceIsVisible(damagesDetails.selfcare_subtitle)",
                  },
                ],
                staticClass: "surface-info",
              },
              [
                _c("p", { staticClass: "text-small-bold gray" }, [
                  _vm._v(_vm._s(_vm.surfaceInfo.key)),
                ]),
                _c("p", { staticClass: "text-medium gray" }, [
                  _vm._v(_vm._s(_vm.surfaceInfo.literal)),
                ]),
              ]
            ),
            _c("div", { staticClass: "damage-card" }, [
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.damagesDetails.images.length >= 1,
                      expression: "damagesDetails.images.length >= 1",
                    },
                  ],
                  staticClass: "headline-medium gray mg mg--b-4",
                },
                [
                  _vm._v(
                    _vm._s(_vm.getSubtitle(_vm.damagesDetails.selfcare_title))
                  ),
                ]
              ),
              _vm.damagesDetails.details.length > 0 ||
              _vm.damagesDetails.images.length > 0
                ? _c("div", { staticClass: "list-card-details" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.damagesDetails.details, function (detail) {
                        return _c("li", { staticClass: "mg mg--b-2" }, [
                          _c("p", { staticClass: "text-small-bold gray" }, [
                            _vm._v(_vm._s(detail.key)),
                          ]),
                          _c("p", { staticClass: "text-medium gray" }, [
                            _vm._v(_vm._s(detail.literal)),
                          ]),
                        ])
                      }),
                      0
                    ),
                    _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.getImageSrc(
                                "inputImgEnsemble",
                                _vm.damagesDetails.images
                              ).length >= 1,
                            expression:
                              'getImageSrc("inputImgEnsemble", damagesDetails.images).length >=1',
                          },
                        ],
                        staticClass: "images-list_container mg mg--b-4",
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "text-small-bold gray mg mg--b-2" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("damagesConfirmed.photosEnsemble"))
                            ),
                          ]
                        ),
                        _vm._l(
                          _vm.getImageSrc(
                            "inputImgEnsemble",
                            _vm.damagesDetails.images
                          ),
                          function (image) {
                            return _c("li", [
                              _c("img", { attrs: { src: image } }),
                            ])
                          }
                        ),
                      ],
                      2
                    ),
                    _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.getImageSrc(
                                "inputImgPres",
                                _vm.damagesDetails.images
                              ).length >= 1,
                            expression:
                              'getImageSrc("inputImgPres", damagesDetails.images).length >=1',
                          },
                        ],
                        staticClass: "images-list_container",
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "text-small-bold gray mg mg--b-2" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("damagesConfirmed.photosPres"))
                            ),
                          ]
                        ),
                        _vm._l(
                          _vm.getImageSrc(
                            "inputImgPres",
                            _vm.damagesDetails.images
                          ),
                          function (image) {
                            return _c("li", [
                              _c("img", { attrs: { src: image } }),
                            ])
                          }
                        ),
                      ],
                      2
                    ),
                  ])
                : _vm.damagesDetails.details.length === 0 ||
                  _vm.damagesDetails.images.length === 0
                ? _c("div", { staticClass: "container-message" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "container-icon-extra grid grid--ai-middle grid--jc-middle grid--column",
                      },
                      [
                        _c("svgicon", {
                          attrs: {
                            name: "Info",
                            color: "#005BA5",
                            height: "48",
                            width: "48",
                          },
                        }),
                        _c(
                          "p",
                          { staticClass: "text-medium gray mg mg--t-3" },
                          [_vm._v(_vm._s(_vm.$t("commonDamages.emptyData")))]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "view_actions" },
        [
          _c("buttonBotton", {
            attrs: {
              handleButtonClick: _vm.handleClickAcceptDamages,
              handleButtonClickWhiteBtn: _vm.handleClickReviseDamages,
              title: _vm.$t("actions.confirmAndContinue"),
              titleWhiteBtn: _vm.$t("actions.goBack"),
              btnType: _vm.getBtnType,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }